import { trackLink } from './index';

/**
 * Tracking per le pagine "Iniziative Speciali" secondo le specifiche MAPP/Tealium
 * Documento di riferimento: "Inziative Speciali - IlSole24Ore Tracking Implementation_v1"
 */

interface ProductTrackingData {
  productName: string;
  productPrice: string;
  subscriptionInterval: string;
}

/**
 * Click su "Aderisci all'Offerta" (o "Attiva")
 */
export const trackAderisciOfferta = (data: ProductTrackingData) => {
  trackLink({
    event_name: "S24:iniziative-speciali:aderisci-all-offerta",
    event_type: "click-cta",
    product_name: data.productName,
    product_price: data.productPrice,
    product_subscription_interval: data.subscriptionInterval
  });
};

/**
 * Click su "Prosegui"
 */
export const trackProsegui = (data: ProductTrackingData) => {
  trackLink({
    event_name: "S24:iniziative-speciali:prosegui",
    event_type: "click-cta",
    product_name: data.productName,
    product_price: data.productPrice,
    product_subscription_interval: data.subscriptionInterval
  });
};

/**
 * Click su periodo abbonamento (selezione prodotto/card)
 */
export const trackSpecificheProdotto = (data: ProductTrackingData) => {
  trackLink({
    event_name: "S24:iniziative-speciali:specifiche-prodotto",
    event_type: "click-card",
    product_name: data.productName,
    product_price: data.productPrice,
    product_subscription_interval: data.subscriptionInterval
  });
};

/**
 * Conferma della corretta attivazione (transaction complete)
 */
export const trackTransactionComplete = (data: ProductTrackingData) => {
  trackLink({
    event_name: "transaction_complete",
    event_type: "S24:iniziative-speciali:transaction_complete",
    product_name: data.productName,
    product_price: data.productPrice,
    product_subscription_interval: data.subscriptionInterval
  });
};

/**
 * Click su "Ok" (chiusura modale successo)
 */
export const trackTransactionCompleteOk = (data: ProductTrackingData) => {
  trackLink({
    event_name: "S24:iniziative-speciali:transaction-complete",
    event_type: "click-cta",
    product_name: data.productName,
    product_price: data.productPrice,
    product_subscription_interval: data.subscriptionInterval
  });
};

/**
 * Utility per estrarre i dati del prodotto dal landing
 */
export const extractProductData = (landing: any, selectedProduct?: any): ProductTrackingData | null => {
  try {
    // Usa il prodotto selezionato o il primo disponibile
    const product = selectedProduct || (landing?.plans?.items?.[0]);
    
    if (!product) {
      return null;
    }

    // Estrai il prezzo dalla prima frequency disponibile
    const paymentFrequency = product.paymentFrequencies?.[0];
    const price = paymentFrequency?.price || '0';
    
    // Determina l'intervallo di sottoscrizione
    let interval = 'mensile';
    if (paymentFrequency?.duration) {
      const duration = paymentFrequency.duration.toLowerCase();
      if (duration.includes('year') || duration.includes('anno')) {
        interval = 'annuale';
      } else if (duration.includes('month') || duration.includes('mese')) {
        interval = 'mensile';
      } else if (duration.includes('semester') || duration.includes('semestre')) {
        interval = 'semestrale';
      } else if (duration.includes('bimester') || duration.includes('bimestre')) {
        interval = 'bimestrale';
      }
    }

    return {
      productName: product.title || product.name || 'Prodotto non specificato',
      productPrice: price.toString(),
      subscriptionInterval: interval
    };
  } catch (error) {
    return null;
  }
};
